import TransferTree from './TransferTree';

export default TransferTree;


// WEBPACK FOOTER //
// ./src/components/TransferTree/index.js